(ns ui.autocomplete
  (:require
   ["@radix-ui/react-scroll-area" :as RadixScrollArea]
   ["react" :as react]
   [applied-science.js-interop :as js-interop]
   [clojure.string :as str]
   [ui.chip :refer [chip]]
   [ui.fields :as fields]
   [ui.popover :as popover]
   [ui.utils :refer [clsx]]))

(defn filter-available-options [options values input-value ]
  (->> options
       (filterv #(str/includes? (str/lower-case (:text %))
                                (str/lower-case input-value)))
       (filterv #(not (some (fn [v] (= v (:text %))) values)))))

(defn items-list [{:keys [values on-delete format-value]}]
  (into
   [:<>]
   (for [value values]
     ^{:key value}
     [chip {:on-delete #(on-delete value)}
      (if format-value
        (format-value value)
        value)])))

(defn autocomplete-form-old [{:keys [label options values add-value]}]
  (let [[query set-query] (react/useState "")
        [open? set-open]  (react/useState false)
        available-options (filter-available-options options values query)
        on-open           (fn [e]
                            (when (.-relatedTarget e) (set-open true)) ;; Prevents from keeping the menu open when clicking on the select item
                            true)
        on-close          #(set-open false)
        on-submit         (fn [values]
                            (add-value values)
                            (set-query "")
                            (on-close))]
    [:form {:class "relative"
            :on-submit (fn [e]
                         (.preventDefault e)
                         (on-submit (js-interop/get-in e [:target :elements :new-value])))}
     [fields/select-root {:open            open?
                          :on-open-change  on-close
                          :on-value-change add-value}
      [fields/select-trigger {:class "absolute bottom-0"}]
      [:f> fields/select-radix-content {:options available-options}]]
     [fields/input {:id        "new-value"
                    :label     label
                    :value     query
                    :on-focus  on-open
                    :on-change #(set-query (js-interop/get-in % [:target :value]))}]]))

(defn autocomplete-form [{:keys [label options values add-value]}]
  (let [[query set-query] (react/useState "")
        available-options (filter-available-options options values query)
        on-submit         (fn [values]
                            (add-value values)
                            (set-query ""))]
    [:form {:class "relative"
            :on-submit (fn [e]
                         (.preventDefault e)
                         (on-submit (js-interop/get-in e [:target :elements :new-value])))}
     [popover/popover-root
      [popover/popover-trigger {:as-child true}
       [:div
        [fields/input {:id        "new-value"
                       :label     label
                       :value     query
                       :on-change #(set-query (js-interop/get-in % [:target :value]))}]]]
      [popover/popover-content {:class "w-full p-0"
                                :on-open-auto-focus (fn [e]
                                                      (.preventDefault e))}
       [:> RadixScrollArea/Root {:type "always"}
        [:> RadixScrollArea/Viewport {:class "h-full relative"
                                      :style {:max-height "min(var(--radix-popover-content-available-height), 400px)"
                                              :overflowY  js/undefined}}
         (for [{:keys [text value]} available-options]
           [:div {:key value
                  :class "relative px-2 py-1.5 outline-hidden text-sm hover:text-kleene-dark-05 transition-colors cursor-pointer text-ellipsis"
                  :on-click #(add-value value)}
            text])]
        [:> RadixScrollArea/Scrollbar {:orientation "vertical" :class "w-3 px-0.5 py-1 z-20" :style {:box-sizing "unset"}}
         [:> RadixScrollArea/Thumb {:class "w-full bg-kleene-neutral-02 dark:bg-kleene-dark-03 rounded-md"}]]]]]]))

(defn autocomplete []
  (fn [{:keys [values options on-change format-value label]}]
    (let [add-value         (fn [value] (on-change (conj values value)))
          remove-value      (fn [value] (on-change (remove #(= % value) values)))]
      [:div
       [:f> autocomplete-form {:label     label
                               :add-value add-value
                               :options   options}]

       [:div {:class "flex flex-wrap gap-1 mt-1"}
        [items-list {:values       values
                     :format-value format-value
                     :on-delete    #(remove-value %)}]]])))